import { useNavigate } from "react-router-dom";
import { MarketplaceMain, MarketplaceNavbarButton, MarketplaceNavbarWrapper } from "./MarketplaceNavbar.styled";

export const MarketplaceNavbar = ({ tabList, activeTab }) => {
  const navigate = useNavigate();
  return (
    <MarketplaceNavbarWrapper>
      <div className='container'>
        <MarketplaceMain>
          <h2>TonTake Mаrketplаce</h2>
          <div>
            {tabList.map((tab, i) => (
              <MarketplaceNavbarButton
                key={i}
                className={activeTab === tab && "active"}
                onClick={() => navigate(`/marketplace/${tab.toLowerCase()}`)}>
                {tab}
              </MarketplaceNavbarButton>
            ))}
          </div>
        </MarketplaceMain>
      </div>
    </MarketplaceNavbarWrapper>
  );
};
